<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="6" lg="6">
                    <b-card class="p-4">
                        <b-card-body>
                            <b-form>
                                <h2 class = "text-center">Api Test</h2>
                                <hr>
                                <b-form-group>
                                    <label for="input-1">1. Method 를 선택하세요.</label>
                                    <b-select id="input-1" class="mb-4" v-model="m.way" :options="ways"></b-select>
                                </b-form-group>

                                <b-form-group>
                                    <label for="input-2">2. URL 를 입력하세요.</label>
                                        <b-input-group>
                                            <b-input-group-text style="height:35px;">http://localhost:3300/</b-input-group-text>
                                            <b-form-input id="input-2" class="mb-4" v-model="m.route" placeholder="example.com"required></b-form-input>
                                        </b-input-group>
                                </b-form-group>

                                <b-form-group>
                                    <label for="input-3">3. UserName 을 입력하세요.</label>
                                    <b-form-textarea id="input-3" class="mb-4" v-model="m.username" placeholder="Enter your Email" @keyup.enter="login()" required></b-form-textarea>
                                </b-form-group>

                                <b-form-group>
                                    <label for="input-4">4. Password 를 입력하세요.</label>
                                    <b-form-input type="password" id="input-4" class="mb-4" v-model="m.password" placeholder="Enter your PW" @keyup.enter="login()" required></b-form-input>
                                </b-form-group>

                                <b-form-group>
                                    <label for="input-5">5. Data 전송 방식 을 선택하세요.</label>
                                    <b-select id="input-5" class="mb-4" v-model="m.type" :options="types"></b-select>
                                </b-form-group>
                                <hr>
                                <b-row class = "text-center">
                                    <b-col>
                                        <b-button variant="primary" class="px-4" @click="onSubmit()">Submit</b-button>
                                        <b-button variant="danger" class="px-4" @click="onReset()">Reset</b-button>
                                        <b-button variant="warning" class="px-4" @click="notice()">Notice</b-button>
                                        <b-button variant="secondary" class="px-4" @click="onReturn()">Return</b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import config from '@/config';
import * as _ from 'lodash';
import * as forge from 'node-forge';
import { auth, custom } from '@/service';

//웹 어플리케이션 보안에서 쓰이는 자바 스크립트 암호화 라이브러리 -> forge
//비밀번호 암호화
const hashpw = x => forge.sha256.create().update(x).digest().toHex();
const decode64 = x => forge.util.decodeUtf8(forge.util.decode64((x || '').replace(/_/g, '/').replace(/-/g, '+')));

function getApiHost(){
    switch(process.env.NODE_ENV) {
        case 'development' : return config.baseURL;
        default : return `${location.protocol}//${location.host.replace(/^[^\\.]*\./, 'api.')}/v1`;
  }
}

const baseUrl = getApiHost();
const http = axios.create({
    baseURL: baseUrl,
    timeout: 10000000,
});

http.defaults.headers.get['Content-Type'] = 'application/json'
http.defaults.headers.post['Content-Type'] = 'application/json'

http.interceptors.response.use((response) => response.data, error => Promise.reject(error.response || { status: 500, data: error.message }));

if(location.hostname == 'localhost') {
    window['http'] = http;
}

const api = {
    login: (m) => { 
        return http.post('auth/manager/login', m); 
    },
    profile: (m) => {
        return http.post('auth/manager/profile/get', m); 
    },
    setAuth: (token) => {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    },
    unsetAuth: () => {
        delete http.defaults.headers.common['Authorization'];
    },
    preflight: (m) => {
        return http.post('auth/manager/preflight', m);
    },
    checkPasswordCycle: (m) => {
        return http.post('auth/manager/cycle/password', m);
    },
    refresh: () => {
        return http.get('auth/manager/refresh/' + new Date().getTime());
    }
}

const auth1 = {
    profile: undefined,
    token: undefined,
    exp: undefined,

    loggedIn: () => {
        return !_.isEmpty(auth.profile) && auth.exp > new Date().getTime() / 1000;
    },

    login: async (username, password, otp) => {
        let p = { otp: otp, username: username, password: hashpw(password), ts: new Date().valueOf() }
        
        try {
            let rs = await api.login(p);
            if(!rs || typeof(rs) !== 'string' || !auth.resolve(rs)) {
                throw { status: 301, data : rs }; 
            }

            sessionStorage.setItem('token', rs);
            console.log('auth_login()', 'success');

            return true;
        } catch(e) {
            console.log('auth_login()', 'failed', e.status, e.statusText);

            throw e;
        }
    },

    preflight: async (username, password) => {
        let p = { username: username, password: hashpw(password), ts: new Date().valueOf() }

        try {
            let rs = await api.preflight(p);
            console.log('auth_preflight()', 'success');

            return rs;
        } catch(e) {
            console.log('auth_preflight()', 'failed', e.status, e.statusText);

            throw e;
        }
    },

    checkPasswordCycle: async (m) => {
        try {
            let rs = await api.checkPasswordCycle(m);
            console.log('auth_checkPasswordCycle', 'pass');

            return rs;
        } catch(e) {
            console.log('auth_checkPasswordCycle', 'failed', e.status, e.statusText);

            throw e;
        }
    },

    resolve: (token) => {
        let ts = {}, rs = [];

        try {
            rs = token.split('.');

            if(rs.length != 3) { return false; }

            let info = decode64(rs[1]);
            ts = JSON.parse(info.replace(/\0/g, '')) || {};

            if(_.isEmpty(ts) || !ts.exp || ts.exp < new Date().getTime() / 1000) { return false; }
        } catch(e) { return false; }

        auth.token = token;
        auth.profile = ts.profile;

        if(auth.profile.permissions) { auth.profile.permissions = (auth.profile.permissions || '').toLowerCase() }

        auth.exp = ts.exp;
        api.setAuth(token);
        
        return true;
    }
}

export default{
    data() {
        return {
            lock: false,
            is_require_change_password : false,
            check_preflight: false,
            require_otp: false,
            custom: custom.default,
            m: {
                way:[],
                route:'',
                username:'',
                password:'',
                type:[],
                otp: '',
            },
            ways: [{text: 'Select One', value: null}, 'GET', 'POST', 'PUT', 'DELETE'],
            types: [{text: 'Select One', value: null}, 'text/xml','text/javascript', 'application/xml', 'application/json', 'application/javascript', 'multipart/m-data']
        }
    },

    methods: {
        preflight() {
            return auth.preflight(this.m.username, this.m.password)
        },

        async onSubmit() {
            alert(JSON.stringify(this.m));

            console.log('data : ', this.m);

            //입력을 안했을 경우 submit 되지않음.
            if(_.isEmpty(this.m.way)) {
                return this.$toastr.e('Please select method');
            }
            if(_.isEmpty(this.m.route)){
                return this.$toastr.e('Please enter Url');
            }
            if(_.isEmpty(this.m.username)) {
                return this.$toastr.e('Please enter your Email');
            }
            if(_.isEmpty(this.m.password)){
                return this.$toastr.e('Please enter your Password');
            }
            if(_.isEmpty(this.m.type)){
                return this.$toastr.e('Please select Content-Type');
            }

            try{
                if(!this.check_preflight){
                    this.require_otp = await this.preflight();
                    this.check_preflight = true;
                }

                if(this.require_otp && !this.m.otp) {
                    return this.$toastr.i('please input OTP', 'require')
                }
            }catch(e){
                console.log(e);
            }

            this.lock = true;
            
            try {
                let rs = await auth.login(this.m.username, this.m.password, this.m.otp);
                
                if(rs) {
                    // check password cycle
                    let ts = new Date().getTime();
                    this.is_require_change_password = await auth.checkPasswordCycle({ ts : ts });
                    this.$route.query.redirect = this.is_require_change_password && confirm("now the password change cycle reached, now change it ?")
                    ? "/management/profile/edit"
                    : (auth.profile.permissions.toLowerCase() == 'sales' ? '/dashboard_sales' : '/dashboard')
                }

                console.log(this.$route.query.redirect, 'this.$route.query.redirect', auth.profile.permissions.toLowerCase() == 'sales', auth.profile.permissions.toLowerCase(), 'sales')

                //여기에서 경로 변경
                this.$router.replace(this.$route.query.redirect || (auth.profile.permissions.toLowerCase() == 'sales' ? '/dashboard_sales' : '/dashboard'));
            }catch(e) {
                console.log(e);
            }
            
            this.lock = false;
        },
        
        //입력한 내용 초기화
        onReset(){
            this.m.way = []
            this.m.route = ''
            this.m.username = ''
            this.m.password = ''
            this.m.type = []
        },

        //뒤로 돌아가기
        onReturn(){
            this.$router.push({ name: 'auth_login' });
        },

        async notice(){
            //입력을 안했을 경우 submit 되지않음.
            if(_.isEmpty(this.m.way)) {
                return this.$toastr.e('Please select method');
            }
            if(_.isEmpty(this.m.route)){
                return this.$toastr.e('Please enter Url');
            }
            if(_.isEmpty(this.m.username)) {
                return this.$toastr.e('Please enter your Email');
            }
            if(_.isEmpty(this.m.password)){
                return this.$toastr.e('Please enter your Password');
            }
            if(_.isEmpty(this.m.type)){
                return this.$toastr.e('Please select Content-Type');
            }

            try{
                if(!this.check_preflight){
                    this.require_otp = await this.preflight();
                    this.check_preflight = true;
                }

                if(this.require_otp && !this.m.otp) {
                    return this.$toastr.i('please input OTP', 'require')
                }
            }catch(e){
                console.log(e);
            }

            this.lock = true;

            try {
                let rs = await auth.login(this.m.username, this.m.password, this.m.otp);
                
                if(rs) {
                    // check password cycle
                    let ts = new Date().getTime();
                    this.is_require_change_password = await auth.checkPasswordCycle({ ts : ts });
                    this.$route.query.redirect = this.is_require_change_password && confirm("now the password change cycle reached, now change it ?")
                    ? "/management/profile/edit"
                    : (auth.profile.permissions.toLowerCase() == 'sales' ? '/dashboard_sales' : '/notice_test')
                }

                console.log(this.$route.query.redirect, 'this.$route.query.redirect', auth.profile.permissions.toLowerCase() == 'sales', auth.profile.permissions.toLowerCase(), 'sales')

                // //여기에서 경로 변경
                // this.$router.replace(this.$route.query.redirect || (auth.profile.permissions.toLowerCase() == 'sales' ? '/dashboard_sales' : '/notice_test'));
                
                this.$router.push({ name: 'notice_test' })                           // 여기서 경로 변경
            }catch(e) {
                console.log(e);
            }

            this.lock = false;
        }
    },

    created() {
        console.log('[vue] ApiTest created');
    },
        destroyed(){
        console.log('[vue] ApiTest destroyed');
    },
    mounted(){
        this.custom = custom.setting()
        console.log('custom setting', this.custom)
        console.log('[vue] ApiTest mounted');

        // if(auth.loggedIn()) { this.$router.replace(auth.profile.permissions.toLowerCase() == 'sales' ? '/dashboard_sales' : '/dashboard');  }   //login

        if(auth.loggedIn()) { this.$router.replace(auth.profile.permissions.toLowerCase() == 'sales' ? '/dashboard_sales' : '/notice_test');  }     //notice_test

        //username 이 localStorage 에 남아있어 페이지가 리로드되더라도 username 값은 초기화를 누르지않는이상 남아 있음
        if(window.localStorage.getItem('username')){
            console.log('username');

            this.m.username = window.localStorage.getItem('username');
        }
    }
}
</script>